import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "examen" }
const _hoisted_2 = { class: "background-imagen" }
const _hoisted_3 = { class: "contenedort" }
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<div class=\"epic-text\"><p class=\"epic-title\"><strong>EPIC TEST</strong></p></div><h1 class=\"ready-go\"><span class=\"ready\">Ready? </span><span class=\"go\">Go!</span></h1><div class=\"additional-text\"><p> Estás a solo un paso de poner a prueba tu nivel de inglés y conseguir tu propio Certificado. Recuerda tener listos tus auriculares o altavoces, un micrófono y conexión a internet </p><br><p style=\"font-family:&quot;pbold&quot;, sans-serif;font-weight:500;\"><strong>¡A por todas y buena suerte!</strong></p></div>", 3)
const _hoisted_7 = { class: "start-button-container" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("button", { class: "start-button" }, "EMPEZAR PRUEBA", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_PieDePagina = _resolveComponent("PieDePagina")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_router_link, { to: "/preguntalargo" }, {
              default: _withCtx(() => [
                _hoisted_8
              ]),
              _: 1
            })
          ])
        ])
      ])
    ]),
    _createVNode(_component_PieDePagina)
  ], 64))
}